export default __webpack_public_path__ + "static/media/yd-apply.bad0f31a.png";